import AuthContext from '../../context/AuthContext'
import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { handleDeNorm, normalizePhone, deNormalizePhone, handleNorm } from '../../utils/functions/tools/normalizePhone';
import { DatePicker, DatePickerInput, Breadcrumb, Button, BreadcrumbItem, Tile, Select, SelectItem, NotificationActionButton, InlineNotification, Link, OverflowMenuItem, OverflowMenu, TextInput, Form } from 'carbon-components-react'
import { sleep } from '../../utils/functions/tools/sleep';
import Toast from '../../components/Notification/Toast'
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;


const AddAgreement = ({ match }) => {

    // Other Variables
    let { authTokens } = useContext(AuthContext)
    let [currencies, setCurrencies] = useState(null)
    let [currencyCode, setCurrencyCode] = useState(null)
    let [countries, setCountries] = useState(null)

    const [list, setList] = useState([]);
    let toastProperties = null;

    const [error, setError] = useState(false);
    const history = useHistory()
    const [phoneInput, setPhoneInput] = useState("");

    // General
    const [curDate, setCurDate] = useState(null)

    useEffect(() => {
        document.title = "Add Agreement | WillowBMS"
        let date = new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2)
        setCurDate(date)
    }, [])

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    let createClient = async (values) => {
        values.preventDefault()

        let response = await fetch(`${API_URL}/agreements/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'name': values.target.name.value,
                'startdate': values.target.startdate.value,
                'enddate' : values.target.enddate.value
            })
        })
        let data = await response.json()
        let newAgreement = await JSON.parse(data)["newAgreement"]
        if (response.status === 200) {
            showToast("success", "Success", "Agreement has been added. Please wait for redirect.")
            setError(false)
            await sleep(2000)
            history.push(`/agreements/${newAgreement}`)
        } else {
            setError(true)
        }
    }

    return (
        <div className="bms-page">
            <>
                <Toast toastList={list} />
                <div className="mb-2">
                    <Breadcrumb>
                        <BreadcrumbItem href="/agreements">Agreements</BreadcrumbItem>
                        <span>Add Agreement</span>
                    </Breadcrumb>
                </div>
                <div>
                    <Form onSubmit={(values) => createClient(values)} className="d-flex flex-w">
                        <Tile><h2 className="d-flex">Add Agreement</h2></Tile>
                        <Tile light={true} className="w-full d-flex flex-w" style={{ minHeight: 0 }}>
                            <div className="col-12 m-005">
                                {error && <InlineNotification className="mb-1" kind="error" hideCloseButton={true} title="Error: Unable to add agreement" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
                                <strong className="d-flex">Agreement Information</strong>
                                <p className="text-sm">Enter in the identifiable information for the agreement.</p>
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    required
                                    data-modal-primary-focus
                                    id="name"
                                    name="name"
                                    labelText="Agreement Name"
                                    placeholder="Enter agreement name"
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <DatePicker datePickerType="single" dateFormat="Y-m-d" style={{ marginBottom: '1rem' }}>
                                    <DatePickerInput
                                        required
                                        id="startdate"
                                        name="startdate"
                                        placeholder="yyyy-mm-dd"
                                        pattern="[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[01])"
                                        labelText="Start date"
                                        defaultValue={curDate}
                                    />
                                </DatePicker>
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <DatePicker datePickerType="single" dateFormat="Y-m-d" style={{ marginBottom: '1rem' }}>
                                    <DatePickerInput
                                        id="enddate"
                                        name="enddate"
                                        placeholder="yyyy-mm-dd"
                                        labelText="End date"
                                        pattern="[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[01])"
                                    />
                                </DatePicker>
                            </div>
                            <div className="col-12 m-005 mt-1">
                                <Button
                                    kind="primary"
                                    tabIndex={0}
                                    type="submit"
                                    className="mr-05"
                                >
                                    Add Agreement
                                </Button>
                                <Button
                                    kind="secondary"
                                    tabIndex={1}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Tile>
                    </Form>
                </div>
            </>
        </div >
    )
}

export default AddAgreement